import ShieldHalfWhite from '@assets/images/shield-half-white.svg?react'
import { Text } from '@atbay/component-lib'
import { Container, IconContainer, Title } from './stanceLogo.styles'

interface StanceLogoProps {
    iconColor?: string
    textColor?: string
    onClick?: () => void
    iconGap?: number
}

const StanceLogo = ({ iconColor, textColor, onClick, iconGap }: StanceLogoProps) => {
    return (
        <Container onClick={onClick}>
            <IconContainer iconGap={iconGap}>
                <ShieldHalfWhite
                    width={20}
                    height={24}
                    color={iconColor || textColor}
                />
            </IconContainer>
            <Title color={textColor}>
                <Text textVariant="pri16B">At-Bay</Text>
                <Text textVariant="pri16R">Stance</Text>
            </Title>
        </Container>
    )
}

export default StanceLogo
